import api from '../config/api';
import { InternationalCommittee } from '../types/committee';
import { uniqueInternationalCommittees } from '../utils/committeeUtils';

let committeesCache: InternationalCommittee[] | null = null;
let committeesInflight: Promise<InternationalCommittee[]> | null = null;

export const committeeService = {
  getAllCommittees: async (): Promise<InternationalCommittee[]> => {
    if (committeesCache) {
      return committeesCache;
    }
    if (committeesInflight) {
      return committeesInflight;
    }

    committeesInflight = api
      .get<InternationalCommittee[]>('/committees')
      .then(response => {
        const unique = uniqueInternationalCommittees(
          Array.isArray(response.data) ? response.data : []
        );
        committeesCache = unique;
        return unique;
      })
      .finally(() => {
        committeesInflight = null;
      });

    return committeesInflight;
  },

  getCommittee: async (id: string): Promise<InternationalCommittee> => {
    const response = await api.get<InternationalCommittee>(`/committees/${id}`);
    return response.data;
  },

  /** Clear cached list after admin mutations that change committees. */
  clearCache: (): void => {
    committeesCache = null;
  },
};
